<template>
    <div class="guidePoint-details wallet-lang-tabs" id="collapseExample" v-if="hasRules">
        <ul class="nav nav-pills mb-1" id="rules-tab" role="tablist">
            <template v-for="(value, lang) in messages" :key="lang">
                <li class="nav-item" role="presentation" v-if="value && value?.length > 0">
                    <button class="nav-link" :class="{ active: lang === activeLanguage }" :id="`rules-${lang}-tab`" data-bs-toggle="pill" :data-bs-target="`#pills-${lang}`"
                        type="button" role="tab" :aria-controls="`rules-${lang}`" :aria-selected="lang === activeLanguage" @click="activeLanguage = lang">
                        {{ lang }}
                    </button>
                </li>
            </template>
        </ul>
        <div class="tab-content" id="rules-tabContent">
            <div class="tab-pane fade show active" v-for="(message, lang) in messages" 
                :key="lang" v-show="lang === activeLanguage"   :id="`rules-${lang}`" role="tabpanel" :aria-labelledby="`rules-${lang}-tab`">
                <div v-for="(point, index) in message" :key="index">
                    <div class="guide-list1" v-html="point.description"></div>
                </div>
            </div>
        </div>
    </div>
    <section v-else>
        <div class="description-card-body" v-if="instructionType == 'deposit'">
            <div class="row">
                <div class="col-12">
                    <div class="about-text">
                        <p>1. {{ $t('this-form-is-for-withdrawing-the-amount', 'This form is for withdrawing the amount from the main wallet only') }}.</p>
                        <p>2. {{ $t('the-bonus-wallet-amount-cannot-be-withdrawn', 'The bonus wallet amount cannot be withdrawn by this form') }}.</p>
                        <p>3. {{ $t('do-not-put-withdraw-request-without-betting-with', 'Do not put Withdraw request without betting with deposit amount. Such activity may be identified as Suspicious') }}.</p>
                        <p>4. {{ $t('If-multiple-users-are-using-same-withdraw', 'If multiple users are using same withdraw account then all the linked users will be blocked') }}.</p>
                        <p>5. {{ $t('maximum-withdraw-time-is-45-minutes-then-only-complain', 'Maximum Withdraw time is 45 minutes then only complain on WhatsApp number') }}.</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="description-card-body" v-else>
                <div class="row">
                    <div class="col-12">
                        <div class="about-text">
                            <p>1. {{ $t('deposit-money-only-in-the-below-available', 'Deposit money only in the below available accounts to get the fastest credits and avoid possible delays') }}.</p>
                            <p>2. {{ $t('deposits-made-45-minutes-after-the-account', 'Deposits made 45 minutes after the account removal from the site are vapd & will be added to their wallets') }}.</p>
                            <p>3. {{ $t('site-is-not-responsible-for-money', 'Site is not responsible for money deposited to Old, Inactive or Closed accounts') }}.</p>
                            <p>4. {{ $t('after-deposit-add-your-utr-and-amount', 'After deposit, add your UTR and amount to receive balance') }}.</p>
                            <p>5. {{ $t('neft-receiving-time-varies', 'NEFT receiving time varies from 40 minutes to 2 hours') }}.</p>
                            <p>6. {{ $t('in-case-of-account-modification', 'In case of account modification: payment valid for 1 hour after changing account details in deposit page') }}.</p>
                        </div>
                    </div>
                </div>
            </div>
    </section>
</template>

<script>
export default {
    inject: ['walletConfig'],
    mounted(){
        if (this.messages) {
            this.activeLanguage = Object.entries(this.messages).find(([lang, rules]) => rules.length > 0)?.[0] || null;
        }
    },
    data() {
        return {
            activeLanguage: null,
        };
    },
    computed: {
        messages() {
            return this.walletConfig?.rules?.[this.instructionType] || null;
        },
        hasRules() {
            if (!this.messages) return false;
            return Object.values(this.messages).some(arr => arr && arr.length > 0);
        }
    },
    props: ['instructionType']
};
</script>
<style scoped>
.language-list li {
    list-style: none;
}
</style>